<template>
  <div class="row mx-0 my-0 no-scroll">
    <div class="col-lg-6 col-md-6 col-sm-6 login-img d-flex align-items-center justify-content-center">
      <img
        :alt="Logo"
        :aria-label="Logo"
        src="/images/makbilllogo.png"
        class="img-fluid1"
      />
    </div>
    <div class="col-lg-6 col-md-6 col-sm-6 d-flex align-items-center justify-content-center auth-form">
      <form ref="loginForm" class="d-grid" @submit.prevent="doLogin">
        <h3 class="text-center fw-bold">Login</h3>
        <div class="mb-2">
          <llp-label id="username" :aria-label="Username">Username/Email/Mobile:</llp-label>
          <llp-input
            id="username"
            v-model:modelValue="credential.username"
            :errors="validator.credential.username.$errors"
            class="w-100"
            autocomplete="off"
            @input="clearErrorMessage"
          ></llp-input>
        </div>
        <div class="mb-3">
          <llp-label id="password" :aria-label="Password">Password:</llp-label>
          <llp-input
            id="password"
            v-model:modelValue="credential.password"
            :errors="validator.credential.password.$errors"
            type="password"
            class="w-100"
            autocomplete="off"
            @input="clearErrorMessage"
          ></llp-input>
        </div>
        <div class="mb-3 d-flex align-items-center">
          <llp-label id="captcha" :aria-label="Captcha" class="me-2">Captcha:</llp-label>
          <div v-if="isCaptchaLoading" class="captcha-loader me-2">
            <i class="fas fa-spinner fa-spin"></i>
          </div>
          <img
            v-else
            :src="captchaImage"
            alt="CAPTCHA"
            class="img-fluid ms-3"
            style="max-width: 30%"
          />
          <button
            type="button"
            @click="refreshCaptcha"
            class="btn btn-link"
            aria-label="Refresh CAPTCHA"
            title="Refresh CAPTCHA"
          >
            <i class="fas fa-sync-alt"></i>
          </button>
          <llp-input
            id="captcha"
            v-model:modelValue="credential.captcha"
            :errors="validator.credential.captcha.$errors"
            class="w-100"
            autocomplete="off"
            style="min-width: 100px"
            @input="clearErrorMessage"
          ></llp-input>
        </div>
        <div class="mb-3">
          <llp-label id="sendOTpLabel" :aria-label="sendOtp">Send OTP to:</llp-label>
          <llp-radio
            id="sendOptions"
            :options="[
              { id: 'email', name: 'Email' },
              { id: 'mobile', name: 'Mobile' },
            ]"
            class="w-100"
            v-model="credential.selectedOtpOption"
            autocomplete="off"
          ></llp-radio>
        </div>

        <div class="mb-3">
          <p v-if="errorMessage" class="text-danger">{{ errorMessage }}</p>
        </div>

        <div class="mb-3 text-center">
          <llp-button
            :loadSpinner="showLoginSpinner"
            classNames="btn-secondary text-white new-btn"
            type="submit"
          >Login</llp-button>
        </div>

        <div class="text-center">
          <p>
            Lost or forgot your password? You can change it with
            <router-link to="/forgot-password" class="fw-bold">
              reset password
            </router-link>
            .
            <router-link to="/register" class="fw-bold"> register</router-link>
          </p>
        </div>
      </form>
    </div>
  </div>

  <llp-toast ref="toast"></llp-toast>
</template>

<script>
import { helpers, required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import NetworkService from "../../services/network.service.js";
import axios from "axios";

export default {
  name: "LoginPage",
  setup: () => ({ validator: useVuelidate() }),
  data() {
    return {
      credential: {
        username: "",
        password: "",
        captcha: "",
        selectedOtpOption: "email",
      },
      captchaImage: "",
      captchaKey: "",
      errorMessage: null,
      showLoginSpinner: false,
      isCaptchaLoading: false,
    };
  },
  validations() {
    return {
      credential: {
        username: {
          required: helpers.withMessage("Username is required.", required),
        },
        password: {
          required: helpers.withMessage("Password is required.", required),
        },
        captcha: {
          required: helpers.withMessage("CAPTCHA is required.", required),
        },
      },
    };
  },
  methods: {
    clearErrorMessage() {
      this.errorMessage = null;
    },

    async doLogin() {
      this.errorMessage = "";
      this.validator
        .$validate()
        .then(async (isValid) => {
          if (!isValid) return Promise.reject();
          this.showLoginSpinner = true;
          const data = {
            name: this.credential.username,
            password: this.credential.password,
            captcha: this.credential.captcha,
            key: this.captchaKey,
            send_otp_to: this.credential.selectedOtpOption,
          };

          try {
            const response = await NetworkService.post("check-login", data, {
              includeToken: false,
            });
            localStorage.setItem("User_id", response.data.user_id);
            if (response.data && response.data.user_id) {
              const userId = response.data.user_id;
              this.showLoginSpinner = false;
              this.$router.push(`/otp/${userId}`);
            }
          } catch (error) {
            this.showLoginSpinner = false;
            await this.refreshCaptcha();
            if (error.errors && error.errors.captcha) {
              this.errorMessage = error.errors.captcha[0];
            }
             else if (error.message == "Invalid credentials") {
              this.errorMessage =
                "Invalid username or password. Please try again.";
            }
             else if (error.errors) {
              this.errorMessage =
                "User is inactive. Please contact admin to activate your account.";
            }
            else {
              this.errorMessage = error.message;
            }
          }
        })
        .catch(() => {
          this.showLoginSpinner = false;
          this.errorMessage = "Please enter your details.";
        });
    },

    async refreshCaptcha() {
      this.isCaptchaLoading = true;
      this.credential.captcha = "";
      try {
      
        const response = await axios.get(
          "https://connect.makbill.com/captcha/api/default"
        );
        this.captchaImage = response.data.img;
        this.captchaKey = response.data.key;
      } catch (error) {
        this.errorMessage = "Failed to load CAPTCHA. Please try again.";
      } finally {
        this.isCaptchaLoading = false;
      }
    },
  },

  async mounted() {
    await this.refreshCaptcha();
  },
};
</script>

<style scoped>
.captcha-loader {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 20px;
}

.llp-input {
  max-width: 100%;
}

@media (max-width: 576px) {
  .captcha-loader {
    margin-bottom: 10px;
  }
  .d-flex {
    flex-direction: column;
    align-items: flex-start;
  }
}

.col-lg-5 {
  display: flex;
  align-items: center;
  justify-content: center;
}

</style>
